// 🔴 ETI-82 — « Mon lien » : le commercial (role régie) retrouve SON lien de
// soumission et le copie. 🔑 Filtre SERVEUR `user_id` : un commercial ⛔ ne voit
// JAMAIS le lien d'un autre (contrôle backend, pas ici).
import React, { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { Copy, Link2 } from "lucide-react";

import { Button } from "../../../components/ui/button";
import { monLien } from "./api";

async function copier(lien) {
  try {
    await navigator.clipboard.writeText(lien);
    toast.success("Lien copié");
  } catch {
    toast.error("Copie impossible — sélectionne et copie manuellement");
  }
}

export default function MonLienCommercial({ tenantId }) {
  const [liens, setLiens] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const r = await monLien(tenantId);
      setLiens((r.liens || []).filter((l) => l.actif));
    } catch {
      // Silencieux : l'absence de lien n'est pas une erreur (le commercial attend
      // que son admin lui en émette un). On n'affiche simplement rien.
      setLiens([]);
    } finally {
      setLoading(false);
    }
  }, [tenantId]);

  useEffect(() => { load(); }, [load]);

  if (loading || liens.length === 0) return null;

  return (
    <div className="mb-3" style={{
      background: "var(--oh-bg-elevated)", border: "0.5px solid var(--oh-border)",
      borderRadius: 12, padding: 16,
    }}>
      <div className="flex items-center gap-2 mb-2" style={{ color: "var(--oh-text)" }}>
        <Link2 className="w-4 h-4" style={{ color: "var(--oh-accent-text)" }} />
        <span style={{ fontWeight: 500 }}>Mon lien de soumission</span>
      </div>
      <p style={{ color: "var(--oh-text-secondary)", fontSize: 13, marginBottom: 8 }}>
        Partage ce lien à tes prospects : leurs soumissions te seront attribuées automatiquement.
      </p>
      <div className="space-y-2">
        {liens.map((l) => (
          <div key={l.empreinte} className="flex items-center gap-2 flex-wrap" style={{
            background: "var(--oh-stat-blue-bg)", color: "var(--oh-stat-blue-text)",
            borderRadius: 8, padding: "8px 12px",
          }}>
            <span style={{ fontSize: 13, fontWeight: 500 }}>{l.operation_code}</span>
            {l.a_regenerer
              ? <span style={{ fontSize: 12, color: "var(--oh-stat-amber-text)" }}>
                  lien à régénérer (demande à ton administrateur)
                </span>
              : l.lien
                ? <>
                    <code style={{ fontSize: 12, wordBreak: "break-all", flex: "1 1 240px" }} data-testid="eti82-mon-lien">{l.lien}</code>
                    <Button variant="outline" size="sm" className="h-7 text-xs"
                      onClick={() => copier(l.lien)} aria-label="Copier mon lien" data-testid="eti82-copier-mon-lien">
                      <Copy className="w-3.5 h-3.5 mr-1" /> Copier
                    </Button>
                  </>
                : <span style={{ fontSize: 12 }}>—</span>}
          </div>
        ))}
      </div>
    </div>
  );
}
